export const ENVIRONMENT = process.env.REACT_APP_ENV
export const LOCAL_STORAGE_PREFIX = 'ah-signup-'
export const LOCAL_STORAGE_PERSISTENT_STATE_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-state'
export const LOCAL_STORAGE_COUNTRY_LIST_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-country-list'
export const LOCAL_STORAGE_NEW_ORGANIZATION_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-organization-guid'
export const LOCAL_STORAGE_NEW_FACILITY_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-facility-guid'
export const LOCAL_STORAGE_APPROVED_FACILITIES = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-approved-facilities'
export const LOCAL_STORAGE_USER_TYPE = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-user-type'
export const LOCAL_STORAGE_SESSION_TAG_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-session-tag'
export const LOCAL_STORAGE_IP_API_TRACKER_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-ip-api-tracker'

export const LOCAL_STORAGE_AUTH_KEY = {
  USER_PROFILE: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-auth-user_profile',
  ACCESS_TOKEN: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-auth-access_token',
  ID_TOKEN: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-auth-id_token',
  EXPIRES_AT: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-auth-expires_at',
  POST_LOGIN_TARGET: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-post-login-target',
  MGMT_ACCESS_TOKEN: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-auth-mgmt-access_token',
  MGMT_ID_TOKEN: LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-auth-mgmt-id_token'
}

export const ALEM_HEALTH_EMAIL_SUPPORT = 'mailto:support@alemhealth.com?Subject=Connect%20Signup%20Support%20Request:%20'

export const STUDY_DATE_TIME_FORMATS = {
  upload: {
    patientDob: 'YYYY-MM-DD',
    studyDate: 'YYYY-MM-DD',
    studyTime: 'hh:mm:ss'
  },
  patient: {
    dob: 'DD-MM-YYYY'
  },
  date: 'DD MMM YYYY',
  studyList: 'DD MMM YYYY [[]HH:mm[]]',
  workList: 'DD MMM YYYY, hh:mm A',
  time: 'H:mm A',
  questionnaire: {
    lastMenstrualDate: 'DD / MM / YYYY',
    lastMammogramDate: 'DD / MM / YYYY'
  },
  createdAt: 'HH[H] mm[M] s[S]'
}

export const CONNECT_APP_URL = process.env.REACT_APP_AH_CONNECT_APP_URL
export const ADMIN_APP_URL = 'https://admin.alem.health'

export const validEmailRegularExpression = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
// export const validEmailRegularExpression = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const phoneNumberFields = [ 'userPhone', 'userGroupPhone', 'userFacilityPhone', 'phone' ]

export const allowSlackNotifications = ENVIRONMENT !== 'local'
export const SLACK_APP_NAME = 'Connect Signup App'
export const SLACK_APP_TYPE = process.env.REACT_APP_SLACK_MODE
export const SLACK_WEB_HOOK = 'https://hooks.slack.com/services/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'
export const ZAPIER_WEB_HOOK = 'https://hooks.zapier.com/hooks/catch/599828/omjjbte/'

export const IP_VERIFY_SERVICE = 'https://ipapi.co/json/' // 'https://api.ipdata.co'

export const WELCOME_MESSAGE_TEMPLATE_ID = 'WELCOME_NEW_USER'

export const COUNTRY_LIST_ENDPOINT = 'https://restcountries.eu/rest/v2/all'

const POST_SIGNUP_ROOT_URL = 'https://alemhealthapi.azure-api.net'

export const SLACK_ENDPOINT = 'https://hooks.slack.com/services/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'
export const SEND_EMAIL_VERIFICATION_CODE_ENDPOINT = 'https://alemhealthapi.azure-api.net/signup/api/email-verification/send-code/'
export const VERIFY_EMAIL_VERIFICATION_CODE_ENDPOINT = 'https://alemhealthapi.azure-api.net/signup/api/email-verification/verify-code/'
export const PHYSICIAN_API_ENDPOINT = 'https://physiciansignupbe.azurewebsites.net/signup'
export const FACILITY_ENDPOINT = POST_SIGNUP_ROOT_URL + '/ahfacility/facility'
export const GROUP_ENDPOINT = POST_SIGNUP_ROOT_URL + '/teleradsetting/api/group'
export const USER_EXISTING_ENDPOINT = POST_SIGNUP_ROOT_URL + '/teleradsetting/api/users'


export const PRE_SIGNUP_SUBSCRIPTION_KEY = '50bed87351684bc88eb8fcfd4fdadeda;product=alemhealth'
export const POST_SIGNUP_SUBSCRIPTION_KEY = '448b311854224b4c8cfe233c0551ec8e'

